// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, OnInit } from '@angular/core';
import { OEM } from '@interfaces/user.interfaces';
import { DealershipService } from '@services/dealership.service';
import { takeWhile } from 'rxjs';
import { tenantIsStellantis } from 'src/app/utils/utils';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
    private isComponentAlive = true;

    public companyImage: string = null;
    public productImage: string = null;

    constructor(private readonly dealershipService: DealershipService) {}

    ngOnInit() {
        this.setImages();
    }

    private oemChange(): void {
        this.dealershipService.dealershipUpdate$.pipe(takeWhile(() => this.isComponentAlive)).subscribe((dealer) => {
            if (dealer.oemName === OEM.stellantis) {
                this.companyImage = '../../../assets/img/stellantis-logo-white.png';
                this.productImage = '../../../assets/img/ez-docs-logo-white.png';
            } else {
                this.companyImage = '../../assets/img/1-ez-docs-white.png';
                this.productImage = '../../assets/img/cropped-ud-logo-white.png';
            }
        });
    }

    private setImages(): void {
        if (tenantIsStellantis()) {
            this.companyImage = '../../../assets/img/stellantis-logo-white.png';
            this.productImage = '../../../assets/img/ez-docs-logo-white.png';
        } else {
            this.companyImage = '../../assets/img/1-ez-docs-white.png';
            this.productImage = '../../assets/img/cropped-ud-logo-white.png';
        }
    }
}
